import React, { Component } from "react";
import config from "../../config";
import { Card, Jumbotron, Col, Form, Button, Table } from "react-bootstrap";
import errores from "../../middleware/errordb";
import Mensajes from "../subcomponent/mensajes";
import Menu from "../menu";
import ModalConfirm from "../subcomponent/modalConfirm";
import funciones from '../../middleware/funciones'

export class HomologacionNomina extends Component {
  constructor(props) {
    super(props);

    const currentCompany = sessionStorage.getItem("company");
    //const currentUserType = sessionStorage.getItem("tipo");
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!mm
    const yyyy = today.getFullYear();
    const todayFormat = yyyy + "-" + mm + "-" + dd;
    this.state = {
      evento: 1,
      fecha: todayFormat,
      codigo: "0",
      erp_code: "",
      descripcion: "",
      mostrarMensaje: false,
      empresa: currentCompany,
      homologacionNomina: [],
      code_erp: "",
      mensaje: "",
      textButton: "Crear Homologacion",
    };
  }

  componentDidMount() {
    this.infoHomologacion();
  }

  infoHomologacion = () => {
    const empresaEdicion = this.state.empresa;
    if (empresaEdicion) {
      const datasend = {
        method: "GET",

        headers: {
          "Content-Type": "application/json",
          empresa: this.state.empresa,
          tipo: this.state.tipo,
        },
      };
      fetch(config.servBackEnd + "/payroll/homologation", datasend)
        .then((response) => response.json())
        .then((data) => {
          if (data.ok) {
            console.log(data);
            const homologacionNomina = data.data;
            this.setState({ homologacionNomina });
          } else {
            this.setState({
              mostrarMensaje: true,
              mensaje: "Sin homologaciones creados",
            });
          }
        });
    }
  };

  createLine = (event) => {
    event.preventDefault();
    this.setState({ show: true });
  };

  enviarInfo = () => {
    this.setState({ show: false });
    event.preventDefault();
    const { evento } = this.state;
    const { erp_code } = this.state;
    const { descripcion } = this.state;
    const { gtic_code } = this.state;
    const { empresa } = this.state;
    const { codigo } = this.state;

    const datasend = {
      method: "POST",
      body: JSON.stringify({
        ID_EMPRESA: empresa,
        ERP_CODE: erp_code,
        DESCRIPCION: descripcion,
        GTIC_CODE: gtic_code,
      }),
      headers: {
        "Content-Type": "application/json",
        tipo: this.state.tipo,
        empresa: this.state.empresa,
      },
    };
    let url = "";
    if (evento) {
      url = "/payroll/homologation/create/";
    } else {
      url = "/payroll/homologation/modify/" + codigo;
    }
    fetch(config.servBackEnd + url, datasend)
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          this.infoHomologacion();
          this.setState({
            mostrarMensaje: true,
            mensaje: "Tarea Finalizada correctamente",
            descripcion: "",
            estado: "1",
            code_erp: "",
            gtic_code: "",
            evento: 1,
            textButton: "Crear Homologacion",
          });
        } else {
          this.setState({
            mostrarMensaje: true,
            mensaje:
              "Error en Tipo de inventario: " +
              errores[data.code] +
              " " +
              data.message,
          });
        }
      });
  };

  edittype = (selected) => {
    this.setState({
      codigo: selected.ID_HOMOLOGACION_NOMINA,
      descripcion: selected.DESCRIPCION || "",
      erp_code: selected.ERP_CODE,
      gtic_code: selected.GTIC_CODE,
      evento: 0,
      textButton: "Modificar Homologacion",
    });
  };
  cleanForm = () => {
    //const { controlCodigo } = this.state;
    this.setState({
      codigo: "0",
      descripcion: "",
      erp_code: "",
      gtic_code: "",
      textButton: "Crear Concepto",
    });
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  render() {
    const { homologacionNomina } = this.state;
    const edittype = this.edittype;
    const mensajeConfirm = this.state.evento
      ? "¿Está seguro que desea crear línea de inventario?"
      : "¿Está seguro que desea modificar la línea de inventario?";
    return (
      <div>
        <Menu></Menu>
        <div>
          <ModalConfirm
            show={this.state.show}
            enviarInfo={this.enviarInfo}
            handleClose={this.handleClose}
            mensaje={mensajeConfirm}
          ></ModalConfirm>
        </div>
        <Jumbotron className="Jumbotron">
          <h2>Homologaciones</h2>
        </Jumbotron>
        <div>
          <Card className="card">
            <Card.Body>
              <Form className="form" onSubmit={this.createLine}>
                <Form.Row>
                  <Form.Group as={Col} controlId="">
                    <Form.Label>Codigo Concepto</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={(e) =>
                        this.setState({
                          erp_code: e.target.value.toUpperCase(),
                        })
                      }
                      value={this.state.erp_code}
                      required
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="">
                    <Form.Label>Descripcion(Opcional)</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={(e) =>
                        this.setState({
                          descripcion: e.target.value.toUpperCase(),
                        })
                      }
                      value={this.state.descripcion}
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="formGridbase">
                    <Form.Label>Codigo DIAN</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={(e) =>
                        this.setState({ gtic_code: e.target.value })
                      }
                      value={this.state.gtic_code}
                      required
                    >
                      <option value="">--Seleccione--</option>
                      <option value="01">01 - HRED</option>
                      <option value="02">02 - HEN</option>
                      <option value="03">03 - HRN</option>
                      <option value="04">04 - HEDDF</option>
                      <option value="05">05 - HRDDF</option>
                      <option value="06">06 - HENDF</option>
                      <option value="07">07 - HRNDF</option>
                      <option value="08">08 - VACACIONES</option>
                      <option value="09">09 - LICENCIA PATERNIDAD/MATERNIDAD</option>
                      <option value="10">10 - LINCENCIA REMUNERADA</option>
                      <option value="11">11 - LINCENCIA NO REMUNERADA</option>
                      <option value="12">12 - OTRO DEVENGADO</option>
                      <option value="13">13 - PRIMA</option>
                      <option value="14-1">14-1 INCAPACIDAD COMUN</option>
                      <option value="14-2">14-2 INCAPACIDAD PROFESIONAL</option>
                      <option value="14-3">14-3 INCAPACIDAD LABORAL</option>
                      <option value="18">18 - SUELDO</option>
                      <option value="19">19 - CESANTIAS</option>
                      <option value="22">22 - AUXILIO TRANSPORTE</option>
                      <option value="23">23 - INTERESES CESANTIAS</option>
                      <option value="24">24 - BONIFICACIONES SALARIALES</option>
                      <option value="25">25 - BONIFICACIONES NO SALARIALES</option>
                      <option value="26">26 - AUXILIOS SALARIALES</option>
                      <option value="27">27 - AUXILIOS NO SALARIALES</option>
                      <option value="28">28 - HUELGAS LEGALES</option>
                      <option value="29">29 - COMPENSACIONES</option>
                      <option value="30">30 - COMISIONES</option>
                      <option value="31">31 - PAGOS_TERCEROS</option>
                      <option value="32">32 - ANTICIPOS</option>
                      <option value="33">33 - DOTACION</option>
                      <option value="34">34 - APOYO</option>
                      <option value="35">35 - TELETRABAJO</option>
                      <option value="36">36 - BONIFICACION_RETIRO</option>
                      <option value="37">37 - INDEMNIZACION</option>
                      <option value="38">38 - REINTEGRO</option>
                      <option value="15">15 - LIBRANZA</option>
                      <option value="16">16 - ANTICIPO</option>
                      <option value="17">17 - OTRAS DEDUCC</option>
                      <option value="20">20 - EPS</option>
                      <option value="21">21 - PENSION</option>
                      <option value="39">39 - SINDICATOS</option>
                      <option value="40">40 - SANCIONES PUBLICA</option>
                      <option value="41">41 - SANCIONES</option>
                      <option value="42">42 - PAGOS_TERCEROS</option>
                      <option value="43">43 - PENSION_VOLUNTARIA</option>
                      <option value="44">44 - RETENCION_FUENTE</option>
                      <option value="45">45 - AFC</option>
                      <option value="46">46 - COOPERATIVA</option>
                      <option value="47">47 - EMBARGO_FISCAL</option>
                      <option value="48">48 - PLAN_COMPLEMENTARIOS</option>
                      <option value="49">49 - EDUCACION</option>
                      <option value="50">50 - REINTEGRO</option>
                      <option value="51">51 - DEUDA</option>
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
                {!this.state.evento && (
                  <Button
                    className="m-3"
                    variant="primary"
                    onClick={this.cleanForm}
                  >
                    Limpiar
                  </Button>
                )}
                <Button className="m-3" variant="primary" type="submit">
                  {this.state.textButton}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>
        <div className="tableFixHead">
          <Table bordered hover>
            <thead>
              <tr>
                <th>Empresa</th>
                <th>Codigo Concepto</th>
                <th>Descripcion Concepto</th>
                <th>Codigo DIAN</th>
                <th colSpan="2">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {homologacionNomina.map(function (currentData, index) {
                return (
                  <tr key={index + "d0"}>
                    <td>{currentData.ID_EMPRESA}</td>
                    <td>{currentData.ERP_CODE}</td>
                    <td>{currentData.DESCRIPCION || ""}</td>
                    <td>{funciones.homologacionDescription(currentData.GTIC_CODE || "")}</td>
                    <td>
                      <Button
                        onClick={() => edittype(currentData)}
                        variant="outline-primary"
                      >
                        Editar
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <Mensajes
          estado={this.state.mostrarMensaje}
          mensaje={this.state.mensaje}
          ocultar={() => this.setState({ mostrarMensaje: false })}
        ></Mensajes>
      </div>
    );
  }
}

export default HomologacionNomina;
